import { SessionEditorModalController } from './modal.controller';
import template from './modal.html';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

/* @ngInject */
export function sessionEditorModal (goModalBootstrap) {

	function open (options: any = {}) {
		options.template = template;
		options.controller = SessionEditorModalController;
		options.controllerAs = '$ctrl';
		options.bindToController = true;
		options.windowClass = options.name = 'session-editor-modal';
		options.backdrop = 'static';
		options.goreact = true; // For new modal styles
		options.modalData = {
			...(options.modalData ?? {}),
			dialogTitleId: options.modalData?.dialogTitleId ?? `session-editor-title-${UniqueIdGeneratorUtil.getId()}`
		};
		return goModalBootstrap.open(options);
	}

	return {
		open
	};
}
